import apiClient from "./apiClient";

// Create license
export const createLicense = async (payload) => {
    try {
        const response = await apiClient.post("/admin/plans", payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error creating license:", error);
        throw error;
    }
};

// Get license
export const getLicense = async (page, per_page) => {
    try {
        const response = await apiClient.get(`/admin/plans?page=${page}&per_page=${per_page}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting license:", error);
        throw error;
    }
};

export const getLicenseForSubscription = async () => {
    try {
        const response = await apiClient.get(`/admin/plans`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting license:", error);
        throw error;
    }
};

// Get license By ID
export const getLicenseById = async (id) => {
    try {
        const response = await apiClient.get(`/admin/plans/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting license by ID:", error);
        throw error;
    }
};

// Update users
export const updateLicense = async (id, payload) => {
    try {
        const response = await apiClient.put(`/admin/plans/${id}`, payload, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating license:", error);
        throw error;
    }
};

// Delete license
export const deleteLicense = async (id) => {
    try {
        const response = await apiClient.delete(`/admin/plans/${id}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error deleting license:", error);
        throw error;
    }
};



// Get currency list
export const getCurrencyList = async () => {
    try {
        const response = await apiClient.get("/admin/currencies/list", {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting currency list:", error);
        throw error;
    }
};

// Get integration list
export const getIntegrationList = async () => {
    try {
        const response = await apiClient.get("/admin/integrations", {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error getting integration list:", error);
        throw error;
    }
};

// Update subscription plan
export const updateSubscriptionPlan = async (id, subscriptionId, payload) => {
    try {
        const response = await apiClient.put(`/admin/subscription/status/${subscriptionId}`, payload, {
            headers: {
                "Content-Type": "application/json",
                organization_id: id
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error updating subscription:", error);
        throw error;
    }
};
